<mat-card>
  <mat-card-header>
    <h3>Comunicação com Candidato</h3>
  </mat-card-header>

  <mat-card-content >

      <mat-form-field class="endereco">
          <mat-label>Endereco</mat-label>
          <input matInput type="text" maxlength="60" name="endereco" [value]="inscricao?.email" >
      </mat-form-field>

      <br>
      <br>


      <mat-form-field class="destino">
          <mat-label>E-mail</mat-label>
          <textarea matInput maxRows="10" placeholder="destino">Aqui entra o texto padrão do e-mail, sujeito a modificação </textarea>
      </mat-form-field>

  </mat-card-content>

      <p></p>
       <p></p>
      <p></p>
      <p></p>
      <p></p>
      <button mat-raised-button name="envia" (click)="goTo()">
          Enviar E-mail
      </button>



      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      <button mat-raised-button name="retorna" routerLink="/administra">
          Retornar
      </button>
      <p></p>
      <p></p>

